import axios, { CancelToken, isCancel } from "axios";
import Cookies from 'universal-cookie';
import { intl } from '../utils/intl';

const cookies = new Cookies();

const axiosV1 = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  responseType: 'json',
  headers: { 'x-access-token': cookies.get('auth'), 'Accept-Language': intl.locale }
});

const axiosV2 = axios.create({
  baseURL: process.env.REACT_APP_API_V2_HOST,
  responseType: 'json',
  headers: { 'x-access-token': cookies.get('auth'), 'Accept-Language': intl.locale }
});

const addInterceptors = (instance) => {
  instance.interceptors.request.use(
    function (config) {
      const token = cookies.get('auth');
      if (token) config.headers['x-access-token'] = token;
      config.headers['Accept-Language'] = intl.locale;
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    try {
      const loginRedirectErrors = ['request not secured', 'login again please'];
      if (loginRedirectErrors.includes(error.response.data.errors[0])) window.location = '/admin/login';
    } catch (e) {
      // proceed with normal error handling
    }
    return Promise.reject(error);
  });
};

addInterceptors(axiosV1);
addInterceptors(axiosV2);

export default axiosV1;
export { axiosV1, axiosV2, CancelToken, isCancel };